export function getUrlParam(paramName) {
    var urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(paramName);
}

export function getStorageValue(key) {
    return window.localStorage.getItem(key);
}


export function putStorageValue(key, value){
    return window.localStorage.setItem(key, value);
}

export function getDeviceFingerprint() {
    return {
        userAgent: navigator.userAgent,
        language: navigator.language,
        platform: navigator.platform,
        screenWidth: screen.width,
        screenHeight: screen.height,
        colorDepth: screen.colorDepth,
        deviceMemory: navigator.deviceMemory || 'unknown',
        hardwareConcurrency: navigator.hardwareConcurrency,
        timezoneOffset: new Date().getTimezoneOffset(),
        touchSupport: 'ontouchstart' in window,
    };
}


export function reportError(param,error) {
    // ����ʵ����Ĵ����ϱ��߼�
    // �����Ƿ���һ��AJAX������ķ���������־ϵͳ
    // Ҳ����ʹ�õ����������ط���
    console.error('Error reported:', error);
    // ʾ����ʹ��fetch�ϱ�����
    try{
        fetch('//www.haoping.fun/api/debug/log', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                exceptionDetail: JSON.stringify({detail: error, param: param}),
                level: "error",
                tag: "exception",
                clientType: "h5",
                msg: "ȫ��δ�����쳣",
                deviceId: localStorage.getItem("deviceId"),
                clientInfo: JSON.stringify({
                    ua: navigator.userAgent,
                    url: location.href
                })
            })
        }).catch(e => {})
    }catch (e){
        console.error(e);
    }
}
